import { clsx } from 'clsx'

import Icon, { type IconTypes } from '@components/utils/Icon'

type StatProps = {
  icon: IconTypes
  label: string
  value?: string | null
  fallbackValue?: string
  className?: string
  testId?: string
}

export function Stat({ icon, label, value, fallbackValue, className, testId }: StatProps) {
  return (
    <div className={clsx('tw:flex tw:min-w-0 tw:flex-col tw:gap-2', className)} data-testid={testId}>
      <dt className="tw:inline-flex tw:items-end tw:gap-1.5 tw:text-gray-true-500 tw:font-bold tw:text-xs tw:uppercase tw:leading-[18px]">
        <Icon type={icon} width={20} height={20} className="tw:shrink-0 tw:text-gray-true-500" />
        {label}
      </dt>
      <dd
        className={clsx(
          'tw:text-sm tw:m-0 tw:min-w-0 tw:wrap-break-word',
          value ? 'tw:text-gray-900' : 'tw:text-gray-true-500 tw:italic'
        )}
      >
        {value || fallbackValue}
      </dd>
    </div>
  )
}
